import React, { Component } from 'react';
import { sanitizeHtml } from '../sanitize';

export class SideContainer extends Component {
    static displayName = SideContainer.name;

    constructor(props) {
        super(props);
        this.state = {
            componentId: props.componentId,
            sideContainer: null
        };
    }

    componentDidMount() {
        this.getComponentData();
    }

    render() {
        let content1;
        let content2;
        if (this.state.sideContainer != null) {
            let sideContainer = this.state.sideContainer;
            content1 = sideContainer.content1;
            content2 = sideContainer.content2;
        }

        return (
            <div className='side-container-container'>
                <div className='side-content' dangerouslySetInnerHTML={{ __html: sanitizeHtml(content1) }}></div>
                <div className='main-content' dangerouslySetInnerHTML={{ __html: sanitizeHtml(content2) }}></div>
            </div>  
        );
    }

    async getComponentData() {
        const response = await fetch('Components/GetSideContainer?componentId=' + this.state.componentId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        const data = await response.json();

        if (data != null) {
            this.setState({
                sideContainer: data
            });
        }
    }
}